import React from "react"
import { RichText, Wrapper, Padder } from 'components'
import { Layout } from "../../components"


export default (props) => {

  const { translations} = props.pageContext
  const { impressumText } = translations

  return(
    <Layout {...props}>
      <Wrapper size="large">
        <Padder size="big">
          <RichText text={impressumText} />
        </Padder>
        
      </Wrapper>
    </Layout>
  )
}
  
